import { Stack, Tabs, Tab } from '@mui/material';

const snapshotsTypes = ['vm-based', 'database-pitr'] as const;
export type SnapshotsType = (typeof snapshotsTypes)[number];

export default function SnapshotsTypesTabs({
  onTypeSelected,
  snapshotType,
}: {
  onTypeSelected: (type: SnapshotsType) => void;
  snapshotType: SnapshotsType;
}) {
  return (
    <Stack
      direction='row'
      alignItems='center'
      padding={'16px 40px 0'}
      minHeight='50px'
      borderBottom='1px solid var(--mui-palette-divider)'
    >
      <Tabs
        onChange={(e, value) => onTypeSelected(value)}
        value={snapshotType}
        className='min-h-[50px] border-b-0'
        sx={{ '.MuiTabs-scroller': { display: 'flex' } }}
      >
        {snapshotsTypes.map((type) => (
          <Tab
            value={type}
            label={type === 'vm-based' ? 'Vm-based snapshots' : 'Database PiTR'}
            key={type}
            className='text-[14px] font-normal px-[12px]'
            disableRipple
          />
        ))}
      </Tabs>
    </Stack>
  );
}
